import React from 'react';
import partnerList from 'data/partner/partnerList';
import Section from 'components/common/Section';
import { Card, Col, Row } from 'react-bootstrap';

const Partners = () => {
  return (
    <>
      <Section bg="light" className="py-3 shadow-sm">
        <Row className="justify-content-center">
          {partnerList.map((partner, index) => (
            <Col xs={12} md={6} lg={3} key={index}>
              <div key={index} className={`py-4 mb-0 w-100 `}>
                <Card className="shadow-none border">
                  <Card.Header className="z-index-1">
                    <Row className="flex-between-between gx-0">
                      <Col className="d-flex align-items-start">
                        <div>
                          <img
                            className="img-fluid"
                            src={partner?.src}
                            alt=""
                            style={{ height: '50px ', width: '50px' }}
                          />
                        </div>
                        <div className="ms-x1">
                          <h6 className="mb-1 text-primary">{partner.text}</h6>
                          <h6 className="mb-0 text-primary fw-bold">
                            {partner.title}
                            <span className="text-info fw-medium ">
                              {' '}
                              {partner.title1}
                            </span>
                          </h6>
                        </div>
                      </Col>
                    </Row>
                  </Card.Header>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      </Section>

      {/* <Section bg="light" className="py-3 shadow-sm">
      <Row className="flex-between-between">
        <Col lg={4}>
          {partnerList.map((partner, index) => (
            <div key={index} className={`py-4 mb-0 w-100 `}>
              <Card className="shadow-none border">
                <Card.Header className="z-index-1">
                  <Row className="flex-between-between gx-0">
                    <Col className="d-flex align-items-bewteen">
                      <div className="">
                        <img
                          className="img-fluid"
                          src={partner?.src}
                          alt=""
                          style={{ height: '50px ', width: '50px' }}
                        />
                      </div>
                      <div className="ms-x1">
                        <h6 className="mb-1 text-primary">{partner.title}</h6>
                        <h6 className="mb-0 text-primary fw-bold">
                          {partner.describe}
                          <span className="text-info fw-medium">
                            {' '}
                            {partner.describe}
                          </span>
                        </h6>
                      </div>
                    </Col>
                  </Row>
                </Card.Header>
              </Card>
            </div>
          ))}
        </Col>
      </Row>
    </Section> */}
    </>
  );
};

export default Partners;
